import Link from '../entities/link';

const linkDataTransformationAfterFetch = (data) => {
    return data.map((row) => {
        return new Link(row);
    });
};

export default linkDataTransformationAfterFetch;
